<template>
    <div class="page contain wider">
        <div class="section info title-only mb-10px">
            <div class="left">
                <h1 class="main-title">Find gecko id</h1>
            </div>
        </div>

        <Preloader v-if="!loaded" class="supercenter"/>
        <template v-else>

            <input type="text" v-model="searchTerm"/>

            <div class="table w-full">
                <thead class="thead">
                    <tr class="tr">
                        <th class="th">Symbol</th>
                        <th class="th">Name</th>
                        <th class="th">Gecko id</th>
                    </tr>
                </thead>
                <tbody class="tbody">
                    <tr class="tr" v-if="filteredCoins.length == 0"><td class="td" colspan="100%">No items found</td></tr>
                    <tr class="tr" v-for="coin in filteredCoins">
                        <td class="td">{{ coin.symbol.toUpperCase() }}</td>
                        <td class="td">{{ coin.name }}</td>
                        <td class="td">{{ coin.id }}</td>
                    </tr>
                </tbody>
            </div>

        </template>

    </div>
</template>

<script>
import { listCoinIds } from '@/api/coingecko'

export default {
    data(){
        return{
            allCoins: [],
            searchTerm: '',
            loaded: false,
        }
    },
    async created(){
        this.allCoins = await listCoinIds()
        this.loaded = true
    },
    computed:{
        filteredCoins(){
            const lowercaseSearch = this.searchTerm.toLowerCase()
            return this.allCoins.filter(x => x.symbol.toLowerCase().includes(lowercaseSearch) || x.name.toLowerCase().includes(lowercaseSearch))
        },
    },
}
</script>